import yellow from "@material-ui/core/colors/yellow"

const styles = theme => ({
  rating: {
    color: theme.palette.grey[300],
    display: "inline-flex",
    alignItems: "center",
    boxShadow: "0 0 0 0 rgba(0,0,0,0)",
    height: "20px",
    padding: "4px",
    paddingLeft: "8px",
    borderRadius: "14px",
    boxSizing: "initial",
    transition: theme.transitions.create("box-shadow", {
      easing: theme.transitions.easing.easeInOut,
    }),
    "&:hover:not($readonly)": {
      boxShadow:
        "0px 0px 0px -1px rgba(0, 0, 0, 0.2), 0px 2px 9px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.2)",
    },
    "&:hover:not($readonly) $superButton": {
      transform: "scale(1)",
    },
  },
  readonly: {},
  ratingIcon: {
    // fontSize: "0.8em",
    marginRight: theme.spacing(1 / 3),
  },
  starIcon: {
    color: theme.palette.primary.dark,
  },
  selectedRating: {
    color: theme.palette.primary.dark,
  },
  ratingCount: {
    color: theme.palette.grey[400],
    fontWeight: 600,
    fontSize: "0.7rem",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1 / 1.5),
  },
  superArea: {
    display: "flex",
  },
  superButton: {
    color: "white",
    height: "20px",
    padding: "0",
    minHeight: "initial",
    lineHeight: "20px",
    width: "20px",
    minWidth: "initial",
    borderRadius: "11px",
    marginLeft: theme.spacing(1 / 1.5),
    transform: "scale(0)",
    transition: theme.transitions.create("transform", {
      easing: theme.transitions.easing.easeInOut,
    }),
  },
  dislike: {
    backgroundColor: theme.palette.secondary.main,
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  like: {
    backgroundColor: yellow[600],
    "&:hover": {
      backgroundColor: yellow[700],
    },
  },
  icon: {
    width: "0.6em",
    height: "0.6em",
  },
})

export default styles
